import React from 'react';
import { motion } from 'framer-motion';
import { Programs } from '../components/Programs';
export function ProgramsPage() {
  return <main className="flex-grow pt-24" data-id="element-589" data-mp="c7v77w3c42ol">
      <div className="bg-midnight text-ivory py-24 text-center relative overflow-hidden" data-id="element-590" data-mp="85qd6w8z541f">
        <div className="absolute top-0 left-0 w-1/2 h-full bg-gradient-to-r from-midnight-light to-transparent opacity-50 pointer-events-none" data-id="element-591" data-mp="87l20lnd9gas" />

        <div className="relative z-10" data-id="element-592" data-mp="3ue026rez75qs">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-6 text-gold" data-id="element-593" data-mp="3uf1gd4rag8cq">
            Get Involved
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-display font-bold tracking-tighter mb-6" data-id="element-594" data-mp="3bojmuxymt8qb">
            Our{' '}
            <span className="font-serif italic font-medium text-gold" data-id="element-595" data-mp="1cyl1sftfdaa3">
              Programs
            </span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-ivory/70 font-medium max-w-2xl mx-auto px-6" data-id="element-596" data-mp="1hwwdkw3a5uuy">
            Join us in our regular meetings and annual outreaches as we build
            the body of Christ.
          </motion.p>
        </div>
      </div>

      <Programs data-id="element-597" data-mp="k95qrq1rfhe6" />
    </main>;
}